import { Outlet } from 'react-router-dom-v5-compat';
import { useNavigationOccurred } from './RouteHooks/NavigationHooks';
import React from 'react';

type WrappingRouteArgs = {
    title: string;
    breadcrumbs?: {
        name: string;
        url: string;
    }[];
    helpLink?: string;
};

export const WrappingRoute = (args: WrappingRouteArgs) => {
    useNavigationOccurred(args);
    return <Outlet/>;
};
